/** Half-up to the centime. Quote lines and stored totals use this scale. */
export function dirhams(amount: number): number {
  return Math.round(Number((amount * 100).toFixed(8))) / 100;
}
